import { axiosInstance } from "../../services/v2/axiosInstance";
import { AvailableScheduleDTO } from "../../models/EnrollmentHistoryDTO";

/*
	Talleres (TAL, PER) y eventos (GADM, AA2, WA4, BDB, BDBT, AAA5, TLT75, FDGYANNISZELAYA) no se matriculan por estos caminos:
	el servidor ya los rechaza con 422; aquí ni se ofrecen. Se sabe cuáles son por /courses/_list (isWorkshopType / isEvent).
	Si esa lista no llega (sin permiso o sin red) no se esconde nada: el servidor sigue siendo quien decide.
*/
const porPlantel: Record<number, Promise<Set<number>>> = {};

export const cursosNoMatriculables = (campusId: number): Promise<Set<number>> => {
	if (!porPlantel[campusId]) {
		porPlantel[campusId] = axiosInstance.get(`/admin/campus/${campusId}/courses/_list`)
			.then((r: any) => new Set<number>((Array.isArray(r.data) ? r.data : (r.data?.data || []))
				.filter((c: any) => c.isWorkshopType || c.isEvent).map((c: any) => Number(c.id))))
			.catch(() => { delete porPlantel[campusId]; return new Set<number>(); });
	}
	return porPlantel[campusId];
};

/** Quita de la lista los horarios de talleres y eventos. */
export const sinTalleresNiEventos = async (campusId: number, horarios: AvailableScheduleDTO[]): Promise<AvailableScheduleDTO[]> => {
	const fuera = await cursosNoMatriculables(campusId);
	return fuera.size < 1 ? horarios : horarios.filter((h) => h.courseId === null || h.courseId === undefined || !fuera.has(Number(h.courseId)));
};
